/**
 * @file The Overlay View component
 * @author Heino Lenting
*/
import { OverlayService } from '../../core/overlay.service';
var OverlayViewComponent = /** @class */ (function () {
    /**
     * Creates an instance of OverlayViewComponent.
     * @param {OverlayService} overlayService The overlay service.
     */
    function OverlayViewComponent(overlayService) {
        this.overlayService = overlayService;
    }
    Object.defineProperty(OverlayViewComponent.prototype, "entityKey", {
        /**
         * Gets the entity key of the current entity.
         * @readonly
         * @type {string}
         */
        get: function () {
            var entity = this.params.entity;
            if (!entity) {
                return '';
            }
            var eKey = entity.entityAspect.getKey();
            var key = '';
            eKey.values.forEach(function (value) { return key += '_' + value; });
            return key.substring(1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OverlayViewComponent.prototype, "params", {
        /**
         * Gets the overlay parameters of this overlay.
         * @readonly
         * @type {OverlayParameters}
         */
        get: function () {
            return this.overlayService.getParams();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OverlayViewComponent.prototype, "configuration", {
        /**
         * Gets the configuration of the overlay.
         * @readonly
         * @type {ComponentConfiguration}
         */
        get: function () {
            return this.params.configuration;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Handles the 'close' action
     */
    OverlayViewComponent.prototype.closeOverlay = function () {
        this.overlayService.closeOverlay();
    };
    /**
     * Check if overlay is open
     */
    OverlayViewComponent.prototype.isOpen = function () {
        return this.overlayService.isOpen();
    };
    /**
     * Check if overlay is closed
     */
    OverlayViewComponent.prototype.isClosed = function () {
        return !this.overlayService.isOpen();
    };
    OverlayViewComponent.prototype.onOverlayClick = function (event) {
        // Only cancel if clicked on the overlay but outside of the Filter area.
        // In other words: the target (clicked item) equals the currentTarget (item the event is attached to).
        if (event.target === event.currentTarget) {
            event.stopPropagation();
            this.closeOverlay();
        }
    };
    return OverlayViewComponent;
}());
export { OverlayViewComponent };
